import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import coin from '@/assets/icons/coin-icn-xs.svg';
import key from '@/assets/icons/key-icn-xs.svg';
import star from '@/assets/icons/star-icn-xs.svg';
import token from '@/assets/icons/token.svg';
import { Mission, MissionItem } from '@/components/Mission';
import { MissionCustom } from '@/types/models/mission';
import { formatNumber } from '@/utils/format';

export type CustomMissionProps = {
  mission: MissionCustom;
  onClick: () => void;
  completed: boolean;
};

export const Custom = observer<CustomMissionProps>(
  ({ mission, onClick, completed }) => {
    const { t } = useTranslation();

    const handleClick = useCallback(() => {
      onClick();
    }, [onClick]);

    return (
      <Mission
        name={t(mission.name)}
        icon={mission.icon}
        completed={completed}
        onClick={handleClick}
        missionBar={
          <>
            {mission.coins && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.coins)}`}</span>
                <img src={coin} />
              </MissionItem>
            )}
            {mission.keys && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.keys)}`}</span>
                <img src={key} />
              </MissionItem>
            )}
            {mission.xp && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.xp)}`}</span>
                <img src={star} />
              </MissionItem>
            )}
            {mission.tokens && (
              <MissionItem>
                <span>{`+ ${formatNumber(mission.tokens)}`}</span>
                <img src={token} />
              </MissionItem>
            )}
          </>
        }
      />
    );
  },
);
